
// 语音文本
Vue.component("voice-list", {
    props: {
        // origintxt: {
        //     type: Array,
        //     default: [],
        // },
        // videos: {
        //     type: Array,
        //     default: [],
        // },
        videoplayer: {
            type: Object,
            default: {
                audioVideoId: ''
            }
        },
        multi_view_player: {
            type: Object,
            default: {
                videoId: ''
            }
        },
        videocurrent: {
            type: Number,
            default: 0,
        },
        knowledge_point: {
            type: Array,
        },
        inpoint: {
            default: 0
        },
        outpoint: {
            default: 0
        },
        fragment: {
            type: Array,
            required: false,
            default: []
        },
    },
    data() {
        return {
            btnStyle: {},
            selectedLy: [],
            originVideoText: [],
            videoText: [],
            lang: '',
            knowledgePointLoading: false,
            knowledgePointInfo: {},
            knowledgePointConfig: {
                visible: false,
                left: 200,
                top: 300,
            },
            selectKnowledgePoint: {},
            expanded: false,
            oldVideoId: null,
            ifScrollOrHover: false,
            timeouter: null,
            textData: [],//语言列表
        };
    },
    computed: {
        hasLang() {
            if (this.originVideoText[0] && this.originVideoText[0].text_en) {
                return true
            }
            return false
        },
        showVideoText({ videoText, fragment }) {
            return videoText.map((list) => {
                let arr = [...list]
                if (fragment.length) {
                    arr = arr.filter(item => {
                        const curr = (item._in || 0) / 10000000
                        return fragment.find(([startTime, endTime]) => {
                            return (typeof startTime == 'number' ? (curr >= startTime) : true) && (typeof endTime == 'number' ? (curr <= endTime) : true)
                        })
                    })
                }
                return arr
            }).filter(el => el.length)
        }
    },
    watch: {
        'videoplayer.audioVideoId': {
            handler(videoId) {
                // console.log('获取语音文本',videoId)
                if (!videoId || videoId == this.oldVideoId) return;
                this.getVoiceText(videoId).then()
                this.oldVideoId = videoId
            },
            deep: true,
            immediate: true
        },
        'multi_view_player': {
            handler(player) {
                if (player && player.on) {
                    const getInfo = () => {
                        let videoId = player.voiceUrl?.videoId
                        // console.log('获取语音文本',videoId)
                        if (!videoId || videoId == this.oldVideoId) return;
                        this.getVoiceText(videoId).then()
                        this.oldVideoId = videoId
                    }
                    getInfo()
                    player.off('voiceChange', getInfo)
                    player.on('voiceChange', getInfo)
                }
            },
            immediate: true
        },
        knowledge_point: {
            handler(newVal) {
                this.videoTextFormat()
            },
            deep: true,
            immediate: true
        },
        videocurrent: {
            handler(newVal) {
                this.throttleHandler()
            },
        }
    },
    created() {
        this.throttleHandler = throttle(this.scrollToView, 1000)
    },
    mounted() {
    },
    methods: {
        //超出视窗自动滚动到视窗内
        scrollToView() {
            let currentSelect = document.querySelector('.paragraph .active')
            let scrollDom = currentSelect?.parentNode?.parentNode?.parentNode?.parentNode?.parentNode?.parentNode
            if (currentSelect && scrollDom && !this.ifScrollOrHover) {
                let curRect = currentSelect.getBoundingClientRect()
                let parRect = scrollDom.getBoundingClientRect()
                // console.log(curRect.top, parRect.top, parRect.bottom)
                if ((curRect.top < parRect.top || curRect.bottom > parRect.bottom)) {
                    currentSelect.parentNode?.parentNode?.scrollIntoView({
                        behavior: "smooth",
                    })
                }
            }
        },
        // 添加语音btn
        handleSelectAdd(e) {
            e.stopPropagation();
            // console.log(this.selectedLy, this.originVideoText)
            let selectedVoice = this.originVideoText.filter(el => this.selectedLy.includes(el.guid_))
            let voiceInfo = {
                note: selectedVoice.map(el => el[(this.lang && this.lang != '') ? ('text_' + this.lang) : 'text']).join(''),
                pointIn: selectedVoice[0]._in,
                pointOut: selectedVoice[selectedVoice.length - 1]._out,
            }
            //   console.log('selectedVoice',selectedVoice)
            this.$emit("add-select-voice-note", {
                selectedLy: this.selectedLy,
                originVideoText: this.originVideoText,
                lang: this.lang,
                voiceInfo
            });
            this.clearSelected();
        },
        // 选中语音
        handleVoiceSelect(e) {
            e.stopPropagation();
            let anchor = window.getSelection().anchorNode;
            let target = window.getSelection().extentNode;
            //   console.log('anchor',anchor,'target',target)
            //   debugger;
            if (anchor && target) {
                let aId = anchor.parentElement.dataset.id;
                let tId = target.parentElement.dataset.id;
                if (aId && tId) {
                    this.btnStyle = {
                        top: (anchor.parentElement.offsetTop || 0) - 46 + "px",
                        left: anchor.parentElement.offsetLeft + "px",
                        display: "block",
                    };
                    const aI = this.originVideoText.findIndex(
                        (item) => item.guid_ === anchor.parentElement.dataset.id
                    );
                    const eI = this.originVideoText.findIndex(
                        (item) => item.guid_ === target.parentElement.dataset.id
                    );
                    const selected = this.originVideoText.slice(
                        aI > eI ? eI : aI,
                        aI > eI ? aI + 1 : eI + 1
                    );
                    const lyrics = selected.map((l) => l.guid_);
                    this.selectedLy = lyrics;
                    window.getSelection().removeAllRanges();
                }
            } else {
                this.clearSelected();
            }
        },
        // 取消语音选中
        clearSelected() {
            this.btnStyle = {
                display: "none",
            };
            this.selectedLy = [];
        },
        playerSeek(pointIn) {
            if (this.multi_view_player) {
                this.multi_view_player.seek(pointIn / 10000000)
            } else if (this.videoplayer) {
                this.videoplayer.currentTime = pointIn / 10000000;
                this.videoplayer.play();
            }
        },
        videoTextFormat() {
            const that = this
            let arr = this.originVideoText || [];
            let index = 0;
            let result = [];
            arr.forEach((item, i) => {
                //有出入点限制则排除掉出入点外的文本
                if (this.inpoint && item._in < this.inpoint) return
                if (this.outpoint && item._in > this.outpoint) return
                // 第一个item入栈
                if (i === 0) {
                    result.push([item]);
                    index = item._in;
                } else if ((item._out - index) / VIDEOTIMEUNIT >= LIMIT) {
                    result.push([item]);
                    index = item._out;
                } else {
                    result[result.length - 1].push(item);
                }
            });
            if (this.knowledge_point && this.knowledge_point.length) {
                const reg = new RegExp(this.knowledge_point.map(el => el.name).join('|'), 'g')
                //知识点标记高亮
                result = result.map(arr => {
                    return arr.map(item => {
                        return {
                            ...item,
                            text: item.textLanguage[this.lang].replace(reg, (match) => {
                                // let id = (this.knowledge_point.find(el=>el.name == match) || {}).id
                                //获取匹配到的知识点
                                return `<span style="color:var(--color-primary)" data-name="${match}" class="knowledge_point">${match}<span class="search_icon"></span></span>`
                            })
                        }
                    })
                })
            }
            // console.log('videoTextFormat', result)
            this.videoText = result
            //初始化知识点事件绑定
            this.$nextTick(()=>{
                jQuery('.paragraph .knowledge_point').on('click',function (e){
                    e.stopPropagation()
                    that.showKnowledgePointInfo(e)
                })
            })
        },
        //展示知识点弹框
        showKnowledgePointInfo(e) {
            let dom = e.currentTarget
            // let id = dom.getAttribute('data-id')
            let name = dom.getAttribute('data-name')
            let domInfo = dom.getBoundingClientRect()
            this.knowledgePointConfig.visible = true
            this.knowledgePointConfig.left = domInfo.left - 320
            this.knowledgePointConfig.top = domInfo.top - 200
            this.knowledgePointLoading = true
            setTimeout(() => {
                this.knowledgePointLoading = false
                this.selectKnowledgePoint = this.knowledge_point.find(el => el.name == name)
                // console.log(this.selectKnowledgePoint)
            }, 500)
        },
        clickToggle() {
            this.expanded = !this.expanded
        },
        getVoiceText(videoId) {
            this.originVideoText = []
            return new Promise((resolve) => {
                // console.log('获取语音文本', videoId)
                API.reqVoiceTextList({
                    contentid: videoId,
                    metadataType: "model_sobey_smart_voice_"
                }).then((res) => {
                    // console.log(res);
                    if (res && res.success) {
                        if (res?.data && res.data?.data.length > 0) {
                            // setVoice(res.data.data[0].metadata.sort((a, b) => a._in - b._in));
                            this.originVideoText = res.data.data[0].metadata;
                            let languageList = res.data.data[0].languageList
                            // this.$emit("has_track_flag", {
                            //     zh: this.originVideoText.find(el => el.text),
                            //     en: this.originVideoText.find(el => el.text_en)
                            // });
                            let textFlag = {}
                            this.textData = languageList.map(el => {
                                let key = Object.keys(el)[0]
                                textFlag[key] = el[key]
                                return {
                                    key,
                                    name: el[key],
                                    data: this.originVideoText.find(data => data.textLanguage['text_' + key])
                                }
                            }).filter(el => el.data)
                            if (!this.textData.length) {
                                this.$emit("has_track_flag", false);
                                return
                            }
                            this.lang = this.textData[0].key
                            // console.log('this.textData', this.textData)
                            this.$emit("has_track_flag", textFlag);
                        } else {
                            // this.originVideoText = []
                            this.$emit("has_track_flag", false);
                        }
                        resolve(this.originVideoText)
                    } else {
                        resolve([])
                        this.$emit("has_track_flag", false);
                    }
                }
                ).catch(() => {
                    resolve([])
                    this.$emit("has_track_flag", false);
                }).finally(() => {
                    this.videoTextFormat()
                })
            })
        },
        handleEvent(e) {
            const that = this
            // console.log('handleEvent', e)
            if (that.timeouter) {
                clearTimeout(that.timeouter)
                that.timeouter = null
            }
            that.ifScrollOrHover = true
            that.timeouter = setTimeout(() => {
                that.ifScrollOrHover = false
            }, 5 * 1000);
        }
    },
    mounted() {
        window.videolist = this
        // 取消掉selection后的选中
        window.addEventListener("click", this.clearSelected);
    },
    beforeDestroy() {
        window.removeEventListener("click", this.clearSelected);
    },
    template: `
        <div>
            <el-select v-model="lang" :placeholder="$t('请选择')" size="small" v-show="hasLang">
              <el-option v-for="item in textData" :key="item.key" :label="item.name" :value="item.key"> </el-option>
            </el-select>
            <div class="voice_list_tips">
                <i class="el-icon-warning-outline"></i>{{$t('此文本为智能语音转写结果，可能存有少量误差，仅供参考')}}
            </div>
            <div class="voice_list" @mousewheel="handleEvent" @mousemove="handleEvent">
                <el-empty
                    v-if="this.showVideoText.length <= 0"
                    :description="$t('暂无语音文本')"
                >
                </el-empty>
                <div v-else @click="handleVoiceSelect" class="course_attach_wrapper">
                    <div class="paragraph" v-for="(para,pi) in showVideoText" :key="'voice'+pi">
                        <div class="point_in" v-if="para.length"><span>{{durationTrans(para[0]._in)}}</span></div>
                        <span
                            v-for="(ly, index) in para"
                            :key="'text'+index"
                        >
                            <span
                                :class="{selected:ly.selected || selectedLy.includes(ly.guid_),active:ly._in<videocurrent && ly._out > videocurrent}"
                                slot="reference"
                                :data-id="ly.guid_"
                                @click="playerSeek(ly._in)"
                                v-html="lang?ly.textLanguage['text_' + lang]: ly.text"
                                >
                            </span>
                        </span>
                        <div
                            class="add_note_btn_select"
                            :style="btnStyle"
                            @click="handleSelectAdd"
                        >
                            {{$t('添加到笔记')}}
                        </div>
                    </div>
                </div>
                <div class="knowledge_point_modal" v-loading="knowledgePointLoading" v-show="knowledgePointConfig.visible" :style="{left:knowledgePointConfig.left+'px',top:knowledgePointConfig.top+'px'}">
                    <div class="mask" @click="knowledgePointConfig.visible = false"></div>
                    <div class="title">
                        <span>{{selectKnowledgePoint.name || '-'}}</span>
                        <a class="el-icon-close" @click="knowledgePointConfig.visible = false"></a>
                    </div>
                    <div class="content">
                        <div class="tips" v-if="selectKnowledgePoint.from">{{$t('来自')}}<a target="_blank" :href="selectKnowledgePoint.link">{{selectKnowledgePoint.from.title || '-'}}</a></div>
                        <div class="detail">
                            <text-clamp :text="selectKnowledgePoint.content || '-'" :maxLines="5" :ifInit="selectKnowledgePoint.content">
                                <template v-slot:default="{ clickToggle, expanded }">
                                <a @click="clickToggle" class="open_close_btn">
                                    {{ expanded ? $t("收起") : $t("展开") }}
                                </a>
                                </template>
                            </text-clamp>
                        </div>
                        <video controls  :src="selectKnowledgePoint.video"></video>
                        <div v-if="selectKnowledgePoint.compareKnwoledge">
                        对比辨析知识点：<a v-for="item,i in selectKnowledgePoint.compareKnwoledge || []" href="javaScript:void(0);">{{item.title || '-'}}{{i == selectKnowledgePoint.compareKnwoledge.length-1?'':'、'}}</a>
                        </div>
                        <div v-if="selectKnowledgePoint.continuedKnowledge">{{$t('前序知识点')}}：<a v-for="item,i in selectKnowledgePoint.continuedKnowledge || []" href="javaScript:void(0);">{{item.title || '-'}}{{i == selectKnowledgePoint.continuedKnowledge.length-1?'':'、'}}</a></div>
                        <div v-if="selectKnowledgePoint.subsequentknowledge">{{$t('后续知识点')}}：<a v-for="item,i in selectKnowledgePoint.subsequentknowledge || []" href="javaScript:void(0);">{{item.title || '-'}}{{i == selectKnowledgePoint.subsequentknowledge.length-1?'':'、'}}</a></div>
                    </div>
                    <a class="more_btn">{{$t('更多相关内容')}}</a>
                </div>
            </div>
        </div>
    `,
});